/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
 * @description It sets the data range according to the given options
 * @param filters
 * @returns {object}
 */

import dayjs from "dayjs";
import { isValidCustomDateRange } from "./isValidCustomDateRange";

const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

export const getDateRange = (filters, format = DEFAULT_DATE_FORMAT) => {
  const today = dayjs();

  if (filters?.dateFilter !== "Custom Date") {
    switch (filters.dateFilter) {
      case "Today":
        return {
          from: today.format(format),
          to: today.format(format),
        };

      case "Last 7 Days":
        return {
          from: today.subtract(7, "day").format(format),
          to: today.format(format),
        };

      case "Yesterday":
        return {
          from: today.subtract(1, "day").format(format),
          to: today.subtract(1, "day").format(format),
        };

      case "This Week":
        return {
          from: today.startOf("week").format(format),
          to: today.endOf("week").format(format),
        };

      case "This Month":
        return {
          from: today.startOf("month").format(format),
          to: today.endOf("month").format(format),
        };

      case "Last Month":
        return {
          from: today.subtract(1, "month").startOf("month").format(format),
          to: today.subtract(1, "month").endOf("month").format(format),
        };

      default:
        return null;
    }
  }

  if (
    filters?.customDateFrom &&
    filters?.customDateTo &&
    isValidCustomDateRange(filters.customDateFrom, filters.customDateTo)
  ) {
    return {
      from: dayjs(filters.customDateFrom).format(format),
      to: dayjs(filters.customDateTo).format(format),
    };
  }

  return null;
};
